import synchronize from './submodules/synchronize';


const state = {
};

const mutations = {
};

const actions = {
    async init({ commit, dispatch, state }, params) {
        await dispatch("synchronize/init");
    },
};

export default {
    namespaced: true,
    state,

    actions,
    mutations,
    modules: {
        synchronize: synchronize(),
    }
};
